//
//
//
//
//
//
//


export default {"name":"icon-014872edfbcdd6596627d69d96bd08b6"}

